import { render, staticRenderFns } from "./ReferAFriend.vue?vue&type=template&id=f2bd5d90&"
var script = {}
import style0 from "./ReferAFriend.vue?vue&type=style&index=0&id=f2bd5d90&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports